// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_managed.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppManagedStateSearchService } from "./app_managed";
import type { AppManagedStateSearchTermsResponse } from "./app_managed";
import type { AppManagedStateSearchTermsRequest } from "./app_managed";
import type { SearchAppManagedStateBindingsResponse } from "./app_managed";
import type { SearchAppManagedStateBindingsRequest } from "./app_managed";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppManagedStateService } from "./app_managed";
import type { MutateAppManagedStateBindingRequest } from "./app_managed";
import type { PromoteAppManagedStateBindingRequest } from "./app_managed";
import type { ListAppManagedStateBindingsResponse } from "./app_managed";
import type { ListAppManagedStateBindingsRequest } from "./app_managed";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAppManagedStateBindingResponse } from "./app_managed";
import type { GetAppManagedStateBindingRequest } from "./app_managed";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppManagedStateService
 */
export interface IAppManagedStateServiceClient {
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    get(input: GetAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<GetAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>;
    /**
     * @generated from protobuf rpc: List(c1.api.app.v1.ListAppManagedStateBindingsRequest) returns (c1.api.app.v1.ListAppManagedStateBindingsResponse);
     */
    list(input: ListAppManagedStateBindingsRequest, options?: RpcOptions): UnaryCall<ListAppManagedStateBindingsRequest, ListAppManagedStateBindingsResponse>;
    /**
     * @generated from protobuf rpc: Promote(c1.api.app.v1.PromoteAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    promote(input: PromoteAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<PromoteAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>;
    /**
     * @generated from protobuf rpc: MutateState(c1.api.app.v1.MutateAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    mutateState(input: MutateAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<MutateAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppManagedStateService
 */
export class AppManagedStateServiceClient implements IAppManagedStateServiceClient, ServiceInfo {
    typeName = AppManagedStateService.typeName;
    methods = AppManagedStateService.methods;
    options = AppManagedStateService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    get(input: GetAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<GetAppManagedStateBindingRequest, GetAppManagedStateBindingResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List(c1.api.app.v1.ListAppManagedStateBindingsRequest) returns (c1.api.app.v1.ListAppManagedStateBindingsResponse);
     */
    list(input: ListAppManagedStateBindingsRequest, options?: RpcOptions): UnaryCall<ListAppManagedStateBindingsRequest, ListAppManagedStateBindingsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppManagedStateBindingsRequest, ListAppManagedStateBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Promote(c1.api.app.v1.PromoteAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    promote(input: PromoteAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<PromoteAppManagedStateBindingRequest, GetAppManagedStateBindingResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<PromoteAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MutateState(c1.api.app.v1.MutateAppManagedStateBindingRequest) returns (c1.api.app.v1.GetAppManagedStateBindingResponse);
     */
    mutateState(input: MutateAppManagedStateBindingRequest, options?: RpcOptions): UnaryCall<MutateAppManagedStateBindingRequest, GetAppManagedStateBindingResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<MutateAppManagedStateBindingRequest, GetAppManagedStateBindingResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppManagedStateSearchService
 */
export interface IAppManagedStateSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search(c1.api.app.v1.SearchAppManagedStateBindingsRequest) returns (c1.api.app.v1.SearchAppManagedStateBindingsResponse);
     */
    search(input: SearchAppManagedStateBindingsRequest, options?: RpcOptions): UnaryCall<SearchAppManagedStateBindingsRequest, SearchAppManagedStateBindingsResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms(c1.api.app.v1.AppManagedStateSearchTermsRequest) returns (c1.api.app.v1.AppManagedStateSearchTermsResponse);
     */
    getSearchTerms(input: AppManagedStateSearchTermsRequest, options?: RpcOptions): UnaryCall<AppManagedStateSearchTermsRequest, AppManagedStateSearchTermsResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppManagedStateSearchService
 */
export class AppManagedStateSearchServiceClient implements IAppManagedStateSearchServiceClient, ServiceInfo {
    typeName = AppManagedStateSearchService.typeName;
    methods = AppManagedStateSearchService.methods;
    options = AppManagedStateSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search(c1.api.app.v1.SearchAppManagedStateBindingsRequest) returns (c1.api.app.v1.SearchAppManagedStateBindingsResponse);
     */
    search(input: SearchAppManagedStateBindingsRequest, options?: RpcOptions): UnaryCall<SearchAppManagedStateBindingsRequest, SearchAppManagedStateBindingsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppManagedStateBindingsRequest, SearchAppManagedStateBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms(c1.api.app.v1.AppManagedStateSearchTermsRequest) returns (c1.api.app.v1.AppManagedStateSearchTermsResponse);
     */
    getSearchTerms(input: AppManagedStateSearchTermsRequest, options?: RpcOptions): UnaryCall<AppManagedStateSearchTermsRequest, AppManagedStateSearchTermsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppManagedStateSearchTermsRequest, AppManagedStateSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
}
